<template>
  <div class="">
    <div>
      <div
        v-if="haveLreButton"
        class="has-background-white-bis is-padding is-border-bottom">
        <div class="columns is-centered is-gapless">
          <div class="column is-5 columns is-vcentered">
            <div class="column is-narrow is-size-4">
              <i class="fal fa-5x fa-mail-bulk"></i>
            </div>
            <div class="column is-narrow is-margin-left-large is-padding-top-xxsmall">
              <div class="title is-3 is-marginless has-text-weight-medium">
                LRE simple
              </div>
              <div class="is-margin-top-xxsmall">
                <button
                  @click="sendLre()"
                  :disabled="loadLre"
                  class="button is-small is-light is-border is-transform-none is-fullwidth is-radius">
                  <span
                    v-if="!loadLre"
                    class="is-uppercase">Envoyer</span>
                  <span v-else><i class="fas fa-spinner fa-spin"></i></span>
                </button>
              </div>
            </div>
          </div>
          <div class="column is-5 columns is-vcentered">
            <div class="column is-narrow has-vadBadge--topright has-vadBadge--out-quarter is-size-4">
              <i class="fal fa-5x fa-mail-bulk"></i>
              <span
                class="vadBadge is-large is-bordered has-background-white"
                style="top: 11%;">
                <span class="icon is-size-2">
                  <i class="fas fa-fingerprint"></i>
                </span>
              </span>
            </div>
            <div class="column is-narrow is-margin-left-large is-padding-top-xxsmall">
              <div class="title is-3 is-marginless has-text-weight-medium">
                LRE EIDAS
              </div>
              <div class="is-margin-top-xxsmall">
                <button
                  :disabled="!eidasEnabled"
                  @click="changeModal('before')"
                  :data-tooltip="'Eidas non disponible'"
                  :class="{'tooltip is-tooltip-right': !eidasEnabled}"
                  class="button is-small is-light is-border is-transform-none is-fullwidth is-radius">
                  <span class="is-uppercase">Envoyer</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="helper && haveLreButton"
        class="notification is-warning is-marginless is-min-height-75 is-flex">
        <div class="is-self-centered w100 is-uppercase">
          <b class="is-size-6">LRE simple et EIDAS, quelles différences ?</b>
          <br>
          <span
            class="is-size-7"
            v-html="helper"></span>
        </div>
      </div>
      <div
        v-if="fromAdf"
        class="has-background-white-bis is-padding is-border-bottom">
        <div class="column columns is-12">
          <div class="column is-4">
            <r-label
              :label="'Numéro A/R'"
              :value="courrier.numero_ar"
              :is-required="false"></r-label>
            <div class="field has-addons">
              <div class="control">
                <a class="button is-static is-border is-square">
                  <span class="icon"><i class="fal fa-barcode-read"></i></span>
                </a>
              </div>
              <div class="control is-expanded">
                <v-input
                  id="numero_ar"
                  name="numero_ar"
                  :model="courrier.numero_ar"
                  @input="val => courrier.numero_ar = val"
                  :errors-bag="errors"
                  data-vv-value-path="val"
                  data-vv-as="Numéro A/R">
                </v-input>
              </div>
            </div>
          </div>
          <div class="column is-4 is-padding-left-xxsmall">
            <r-label
              label="Date d'envoi postal A/R le"
              :value="courrier.sending_date"
              :is-required="false"></r-label>
            <div class="field has-addons">
              <p class="control">
                <a class="button is-static is-border is-square"><span class="icon"><i class="fal fa-calendar-alt"></i></span></a>
              </p>
              <p class="control is-expanded">
                <flat-pickr
                  :config="pickerConfig"
                  v-model="courrier.sending_date"
                  class="input"
                  name="sending_date">
                </flat-pickr>
              </p>
            </div>
          </div>
          <div class="column is-4 is-padding-left-xxsmall">
            <r-label
              label="date de réception A/R le"
              :value="courrier.ar_received_date"
              :is-required="false"></r-label>
            <div class="field has-addons">
              <p class="control">
                <a class="button is-static is-border is-square"><span class="icon"><i class="fal fa-mailbox"></i></span></a>
              </p>
              <p class="control is-expanded">
                <flat-pickr
                  :config="pickerConfig"
                  v-model="courrier.ar_received_date"
                  class="input"
                  name="ar_received_date">
                </flat-pickr>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="fromAdf"
      class="is-bottom">
      <div class=" columns is-gapless is-centered has-background-white is-padding-top-small is-padding-bottom-small">
        <div class="column is-4 is-3-widescreen is-margin-right-small">
          <a
            @click="$emit('close')"
            class="button is-light is-uppercase is-fullwidth">
            <span>Annuler</span>
          </a>
        </div>
        <div class="column is-4 is-3-widescreen is-margin-left-small">
          <button
            @click="submit"
            class="button is-success is-uppercase is-fullwidth has-text-white"
            type="submit">
            <span v-if="!loading">Valider</span>
            <span
              v-else
              class="icon"><i class="fas fa-spinner fa-spin"></i></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Error } from '@/mixins'
import { mapGetters } from 'vuex'
const showdown = require('showdown')
export default {
  name: 'RegisteredMail',
  mixins: [Error],
  props: {
    requestElem: {
      type: Object
    },
    buyerPk: {
      type: String
    },
    from: {
      type: String
    },
    appelDeFondIndex: {
      type: [Number, String]
    },
    sruIndex: {
      type: [Number, String]
    }
  },
  data () {
    return {
      loadLre: false,
      helper: null,
      loading: false,
      save: true,
      pickerConfig: {
        altFormat: 'j/m/Y',
        altInput: true,
        dateFormat: 'Z'
      }
    }
  },
  computed: {
    ...mapGetters(['constructionSteps', 'canUseLre', 'eidasEnabled']),
    /**
      * current courrier
      * @returns {object}
      */
    courrier () {
      return this.constructionSteps[this.appelDeFondIndex].letters[this.sruIndex]
    },
    /**
      * from is adf
      * @returns {boolean}
      */
    fromAdf () {
      return this.from === 'adf'
    },
    /**
      * can display lre button
      * @returns {boolean}
      */
    haveLreButton () {
      if (this.fromAdf) {
        return !this.courrier.numero_ar && !this.courrier.sending_date && !this.courrier.ar_received_date && this.canUseLre
      } else {
        return true
      }
    }
  },
  created () {
    this.getHelper()
  },
  methods: {
    /**
      * get Helper
      */
    async getHelper () {
      let id = '24oHGjK7Juk4TVLjlRrENF'
      if (id && this.$contentful) {
        this.$contentful.getEntry(id).then(entry => {
          let converter = new showdown.Converter()
          let text = entry.fields.text
          this.helper = converter.makeHtml(text)
        })
      }
    },
    /**
      * send lre
      */
    async sendLre () {
      this.loadLre = true
      let params = {
        buyer: this.buyerPk,
        eidas: 0
      }
      try {
        let lre
        if (this.fromAdf) {
          params.construction_step_uuid = this.requestElem.step_uuid
          let { data } = await this.$api.post(`/reservations/${this.requestElem.adv_pk}/lre/adf-notice`, params)
          lre = data
        } else {
          let { data } = await this.$api.post(`/reservations/${this.requestElem.adv_pk}/lre/reservation-contract`, params)
          lre = data
        }
        this.$emit('sendInfo', lre)
        this.$emit('goToDemat', lre)
        window.location.reload()
      } catch (err) {
        this.handleError(err)
        console.log(err)
      } finally {
        this.loadLre = false
      }
    },
    /**
      * submit
      */
    async submit () {
      this.loading = true
      try {
        let { data } = await this.$api.axios.put(`reservations/${this.requestElem.adv_pk}/adf/${this.requestElem.step_uuid}/${this.courrier.buyer_pk}`, this.courrier)
        let payload = {
          construstion_steps: data
        }
        await this.$store.dispatch('patchAdvConstructionStep', payload)
        this.$toasted.global.success('Informations enregistrées')
        this.$emit('close')
      } catch (err) {
        this.handleError(err)
        console.log(err)
      } finally {
        this.loading = false
      }
    },
    /**
      * change modal
      * @param {string} val
      */
    changeModal (val) {
      this.$emit('changeModal', val)
    }
  }
}
</script>
